import React, { Component } from 'react';
import './../../assets/css/App.css';
import Service from './service';
import Table from './../../component/table/table/Table';
import TableHead from './../../component/table/table/TableHead';
import TableBody from './../../component/table/table/TableBody';
import TableSearchHeader from './../../component/table/table/TableSearchHeader';
import TablePagination from './../../component/table/pagination';
import Utils from './../../component/utils/utils';
import DatePicker from './../../component/datePicker';
import InputSearchField from './../../component/inputSearchField';
import AdHocViewEnum from './adHocViewEnum';
import Select from './../../component/select';

class TableView extends Component {
    // START private methods
    _callServiceFetch(page) {
        this.setState({
            showMask: true
        });

        var searchParams = this._createSearchParamsObject();
        Service.fetchAdHocReport(page, searchParams, this.viewType).finally(() => {
            this.setState({ showMask: false });
        });
    }

    _callServiceDownloadFile() {
        var searchParams = this._createSearchParamsObject();
        Service.downloadAdHocReport(searchParams, this.viewType);
    }

    _createSearchParamsObject(page) {
        var searchParams = {};
        searchParams.createdDateStart = this.createdDateStart;
        searchParams.createdDateEnd = this.createdDateEnd;
        searchParams.shipDateStart = this.shipDateStart;
        searchParams.shipDateEnd = this.shipDateEnd;
        searchParams.openSearch = this.searchInputFieldValue;
        searchParams.searchStatus = this.statusDropdownValue;

        return searchParams;
    }
    // END private methods

    state = {
        emptyTableMessage: 'No data can be found',
        tableHeaderTitle: "Ad Hoc Shipments",
        pagingMetadata: [],
        responseTableData: {},
        showMask: false
    }

    constructor() {
        super();
        // setting default attribute values
        this.currentPage = 0;
        this.createdDateStart = "";
        this.createdDateEnd = "";
        this.shipDateStart = "";
        this.shipDateEnd = "";
        this.searchInputFieldValue = "";
        this.viewType = AdHocViewEnum.SHIPMENT;
        this.statusDropdownValue = "";

        this.tableHeaderColumnList = [
            { columnName: "Name", key: "name"},
            { columnName: "Shipment ID", key: "shipmentId"},
            { columnName: "Service Level", key: "serviceLevel"},
            { columnName: "Tracking Number", key: "trackingNumber"},
            { columnName: "Status", key: "status"},
            { columnName: "Account ID", key: "accountId"},
            { columnName: "Number Packages", key: "numberPackages"},
        ]
    }

    componentDidMount () {
        var fetchEventForResultData = Service.getEventSignal(this.viewType);
        fetchEventForResultData.add((data) => {
            this.setState({
                responseTableData: data,
                pagingMetadata: data.pagingMetadata
            });
        });
    }

    onStartDateFieldChange = (value) => {
        this.createdDateStart = value;
    };

    onEndDateFieldChange = (value) => {
        this.createdDateEnd = value;
    };

    onStartShipDateFieldChange = (value) => {
        this.shipDateStart = value;
    };

    onEndShipDateFieldChange = (value) => {
        this.shipDateEnd = value;
    };

    onSearchFieldChange = (value) => {
        this.searchInputFieldValue = value;
    };

    // table actions
    searchButtonAction = () => {
        this.currentPage = 1;
        this._callServiceFetch(1);
    };

    jumpToPage = (e) => {
        e.preventDefault();
        var page = e.currentTarget.attributes.getNamedItem('data-page').value;
        this.currentPage = Number(page);
        this._callServiceFetch(page);
    };

    goForwardToPage = (e) => {
        e.preventDefault();
        if (this.currentPage > 0) {
            this.currentPage = this.currentPage + 1;
            this._callServiceFetch(this.currentPage);
        }
    };

    goBackToPage = (e) => {
        e.preventDefault();
        if (this.currentPage > 1) {
            this.currentPage = this.currentPage - 1;
            this._callServiceFetch(this.currentPage);
        }
    };

    jumpToFirstPage = (e) => {
        e.preventDefault();
        this.currentPage = 1;
        this._callServiceFetch(1);
    };

    jumpToLastPage = (e) => {
        e.preventDefault();
        this.currentPage = Number(this.state.pagingMetadata.pageCount);
        this._callServiceFetch(this.currentPage);
    };

    downloadFileAction = () => {
        this._callServiceDownloadFile();
    };

    handlePackageStatusDropdownChange = (event) => {
        this.statusDropdownValue = event.target.value;
    };

    render() {
        return (
            <div>
                <Table>
                    <TableSearchHeader
                        headerClassName = {"fa fa-credit-card"}
                        tableHeaderTitle = {this.state.tableHeaderTitle}
                        searchButtonAction = {this.searchButtonAction}
                        downloadFileAction = {this.downloadFileAction}
                        type = "adHocReport"
                    >
                        <Select name="statusDropdown" className={"packages-status-dropdown"}
                                controlFunc={this.handlePackageStatusDropdownChange}
                                options = {Utils.shipmentStatusDropdownOptions}
                        />
                        <DatePicker
                            fieldId = "adHocShipmentStartDatePicker"
                            placeHolderText = "Created Start Date"
                            onChange = {this.onStartDateFieldChange}
                            fieldType = "startDate"
                        />
                        <DatePicker
                            fieldId = "adHocShipmentEndDatePicker"
                            placeHolderText = "Created End Date"
                            onChange = {this.onEndDateFieldChange}
                            fieldType = "endDate"
                        />
                        <DatePicker
                            fieldId = "adHocShipmentStartShipDatePicker"
                            placeHolderText = "Shipped Start Date"
                            onChange = {this.onStartShipDateFieldChange}
                            fieldType = "startDate"
                        />
                        <DatePicker
                            fieldId = "adHocShipmentEndShipDatePicker"
                            placeHolderText = "Shipped End Date"
                            onChange = {this.onEndShipDateFieldChange}
                            fieldType = "endDate"
                        />
                        <InputSearchField
                            fieldId = "adHocSearchField"
                            placeHolderText = "Search"
                            onChange = {this.onSearchFieldChange}
                        />
                    </TableSearchHeader>
                   <TableHead
                       tableHeaderColumnList = {this.tableHeaderColumnList}
                       type = "adHocReport"
                   />
                   <TableBody
                       tableDataResults = {this.state.responseTableData.results}
                       tableHeaderColumnList = {this.tableHeaderColumnList}
                       type = "adHocReport"
                       showMask = {this.state.showMask}
                   >

                   </TableBody>
                    <TablePagination
                        pagingMetadata={this.state.pagingMetadata}
                        jumpToPage={this.jumpToPage}
                        goForwardToPage={this.goForwardToPage}
                        goBackToPage={this.goBackToPage}
                        jumpToFirstPage={this.jumpToFirstPage}
                        jumpToLastPage={this.jumpToLastPage}>
                    </TablePagination>
                </Table>
            </div>
        );
    }
}

export default TableView;
